const validateAnswer = function (errors, vm) {
  const { value, answerConfig: { requireInd, paramInt01, paramInt02, scoreNumType, limitRangeInd, answerValidInd, answerRangeType, rangeTargetId } } = this
  if (requireInd === '1') {
    if ((value && !String(value).trim()) || vm.$util.isNull(value)) {
      errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
      return !errors.length
    }
  }
  if (vm.$util.isNull(value)) {
    return !errors.length
  }
  let compareValue = value
  compareValue = compareValue * 1
  if (isNaN(compareValue)) {
    errors.push(vm.cvtLang('tipsNumberLimit', vm.surveyInfoLang.tipsNumberLimit))
    return !errors.length
  }
  if (scoreNumType === '01' && !/^-?\d+$/.test(compareValue)) {
    errors.push(vm.cvtLang('tipsIntLimit', vm.surveyInfoLang.tipsIntLimit))
    return !errors.length
  } else if (scoreNumType === '02' && !/^-?(\d+|\d+\.\d{1,1})$/.test(compareValue)) {
    errors.push(vm.cvtLang('tipsOneDecimalLimit', vm.surveyInfoLang.tipsOneDecimalLimit))
    return !errors.length
  } else if (scoreNumType === '03' && !/^-?(\d+|\d+\.\d{1,2})$/.test(compareValue)) {
    errors.push(vm.cvtLang('tipsDecimalLimit', vm.surveyInfoLang.tipsDecimalLimit))
    return !errors.length
  }
  if (limitRangeInd === '1') {
    if (compareValue < paramInt01 || compareValue > paramInt02) {
      let errorMin = paramInt01
      let errorMax = paramInt02
      errors.push(
        `${vm.$t('tipRangeNull')}[${errorMin},${errorMax}]`
      )
      return !errors.length
    }
  }
  if (answerValidInd === '1' && rangeTargetId) {
    let refQu = {}
    let refOption = {}
    let _answerType = ''
    const result = [{
      optionId: '',
      answerType: answerRangeType,
      refQuId: rangeTargetId,
      refOptionId: ''
    }].every(({ optionId, answerType, refQuId, refOptionId }) => {
      refQu = vm.allQuestionList.find(item => item.id === refQuId)
      if (refQu) {
        let refValue = refQu.value
        let compareValue = value
        if (refOptionId) {
          refOption = refQu.optionList.find(item => item.id === refOptionId)
          refValue = refOption.value
        }
        _answerType = answerType
        // eslint-disable-next-line
        return eval(`${compareValue}${answerTypeMapp[answerType]}${refValue}`)
      } else {
        return true
      }
    })
    if (!result) {
      let optionTip = ''
      if (refOption.id) {
        optionTip = ` 选项[${refOption.optionName}]`
      }
      let errorTip = ''
      const answerTypeList = vm.answerTypeList
      if (answerTypeList) {
        errorTip = vm.answerTypeList.find(item => item.value === _answerType).label
      }
      /* ${refQu.value} */
      errors.push(`答案必须${errorTip}${refQu.quCode}.${refQu.title}${optionTip}答案`)
      return !errors.length
    }
  }
  return !errors.length
}

const answerTypeMapp = {
  '01': '===',
  '02': '<',
  '03': '<=',
  '04': '>',
  '05': '>='
}

const validate = function (vm) {
  const errors = []
  return {
    result: validateAnswer.call(this, errors, vm),
    errors
  }
}

const answerValidate = {
  validateAnswer,
  validate
}

export default answerValidate



// WEBPACK FOOTER //
// ./src/components/editor/NumberBox/answerValidate.js